var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorLiabilityInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#carInsuranceSvg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.518 11a4.364 4.364 0 0 0-4.279 3.508l-1.15 5.749a4.001 4.001 0 0 0-2.998 3.437l-.566 5.092a3.997 3.997 0 0 0 1.78 3.786v1.787a2.363 2.363 0 1 0 4.726 0v-1.131h18v1.082a2.301 2.301 0 0 0 4.603 0v-1.658a3.999 3.999 0 0 0 1.906-3.866l-.566-5.092a4.001 4.001 0 0 0-2.806-3.384l-1.16-5.802A4.364 4.364 0 0 0 30.727 11h-13.21Zm-6.577 15.113a2.182 2.182 0 1 1 4.364 0 2.182 2.182 0 0 1-4.364 0Zm24.003-2.182a2.182 2.182 0 1 0 0 4.364 2.182 2.182 0 0 0 0-4.364ZM19.377 13.909c-1.496 0-2.784 1.028-3.078 2.456l-.74 3.605a144.608 144.608 0 0 1 17.141.011l-.743-3.616c-.294-1.428-1.582-2.456-3.078-2.456h-9.502Zm-1.165 10.022a1.455 1.455 0 0 0 0 2.91H29.85a1.455 1.455 0 0 0 0-2.91H18.212Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "carInsuranceSvg",
    x1: 0,
    y1: 0.265,
    x2: 49.218,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB2CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE3D82"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorLiabilityInsurance);
export default __webpack_public_path__ + "static/media/MotorLiabilityInsurance.18d9b9ef8f2283e375c1108b31449064.svg";
export { ForwardRef as ReactComponent };